<style lang="scss">
    .beats{
        margin-top: 10px;
        margin-bottom : 10px;
    }

    .latest{
        margin-top: 30px;
        .widget-title{
            color: #ff5b94;
            font-family: Poppins;
            font-size: 30px;
            font-weight: 600;
            text-transform: uppercase;
        }

        .beat-container {
            padding: 12px;
        }

        .browseAll{
            width: 160px;
            height: 43px;
            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
            border-radius: 5px;
            background-color: #ff1466;

            color: #ffffff;
            font-family: Poppins;
            font-size: 14px;
            font-weight: 500;
            margin-top : 10px;
            padding: 14px 16px;
        }

        .browseAll:hover{
            font-weight: 600 !important;
        }
    }

    @media screen and (max-width: 900px) {
        .latest {
            .beat-container {
                &[class*="col-"] {
                    padding: 4px;
                }
            }
        }
    }

    @media screen and (max-width: 500px) {
        .latest {
            .browseAll{
                width: 100%;
            }
        }
    }

</style>
<template>
    <div class="latest">
        <h3 class="widget-title" :style="$highlightColor">LATEST BEATS</h3>
        <template v-if="latest.length > 0">
            <div class="row" v-if=" display == 'blocks' ">
                <beat-container class="col-xs-6 col-sm-3 col-md-3" :showDownload="true" :display="page.new.display" :showPrice="true" v-for="beat in latest" :key="beat.id" :beat="beat" :image-size='300'></beat-container>
            </div>

            <template v-if="display == 'list'">
                <beat-row-header></beat-row-header>
                <row-beat-container :showDownload="true" :display="page.new.display" v-for="beat in latest" :key="beat.id" :beat="beat" :image-size='50'></row-beat-container>
            </template>

            <router-link v-if="config.defaultBeatsPage" :to="{name: config.defaultBeatsPage.id}" class="btn browseAll" :style="$mainButtonStyle">Browse All</router-link>

        </template>
        <div v-else-if="isLatestLoading" class="text-center">
            <loading-icon></loading-icon>
        </div>
    </div>
</template>

<script>
    import BeatContainer from './../beatcontainer.vue'
    import BeatRowHeader from './../beatrowheader.vue'
    import RowBeatContainer from '../rowbeatcontainer.vue'
    import LoadingIcon from './../loadingicon.vue'
    import Beat from './../../models/beat'
    import Configure from './../../mixins/configure'

	export default {
        props: ['pageId','display'],
	    created() {
            if(this.page.new.display == 'list'){
                this.imagesize = 50;
            }
        },
        components: {
	        BeatContainer,BeatRowHeader,RowBeatContainer,LoadingIcon
        },
        data() {
            return {
                music: [],
                imagesize : 300
            }
        },
        computed: {
            page() {
                if (this.pageId) {
                    return this.config.getPageById(this.pageId)
                }
                return false
            },
            config() {
	            return this.$store.state.currentConfig
            },
            user() {
                return this.$store.state.user
            },
            playlistManager() {
                return this.$store.state.playlistManager
            },
            pagePlaylist() {
                return this.playlistManager.getPagePlaylist()
            },
            latest () {
                return this.$store.state.discoverPlaylist.newBeats
            },
            isLatestLoading () {
              return this.$store.state.discoverPlaylist.newBeatsLoading
            }
        },
        mixins: [Configure],
	}
</script>
